var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264 280",
    style: {
      enableBackground: "new 0 0 264 280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\r\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{mask:url(#mask-2_1_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#2C3E50;}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_1_);}\r\n\t.st6{mask:url(#mask-4_1_);}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#D0C6AC;}\r\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_2_);}\r\n\t.st9{mask:url(#mask-6_1_);}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#EDB98A;}\r\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_3_);}\r\n\t.st12{mask:url(#mask-6_2_);fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\r\n\t.st13{filter:url(#Adobe_OpacityMaskFilter_4_);}\r\n\t.st14{mask:url(#react-mask-952_1_);}\r\n\t.st15{filter:url(#Adobe_OpacityMaskFilter_5_);}\r\n\t.st16{opacity:0.6;mask:url(#react-mask-952_2_);}\r\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.16;}\r\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.7;}\r\n\t.st19{filter:url(#Adobe_OpacityMaskFilter_6_);}\r\n\t.st20{mask:url(#react-mask-934_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_7_);}\r\n\t.st22{mask:url(#react-mask-934_2_);}\r\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:#FF4F6D;}\r\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.6;}\r\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_8_);}\r\n\t.st26{mask:url(#react-mask-925_1_);}\r\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#28354B;}\r\n\t.st28{filter:url(#Adobe_OpacityMaskFilter_9_);}\r\n\t.st29{mask:url(#react-mask-924_1_);}\r\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#4A312C;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with getavataaars.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825.000000, -1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(825.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 120,
    cy: 120,
    r: 120
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1_1_",
    className: "st2",
    cx: 120,
    cy: 120,
    r: 120
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 240,
    height: 240
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 265,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 265,
    height: 280,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "st2",
    d: "M12,160c0,66.3,53.7,120,120,120s120-53.7,120-120h12V0H0v160H12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124,144.6V163h4l0,0c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4 c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0 c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: -32,
    y: 0,
    width: 264,
    height: 244
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -32,
    y: 0,
    width: 264,
    height: 244,
    id: "mask-6_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5_1_",
    className: "st2",
    d: "M124,144.6V163h4l0,0c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4 c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0 c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    width: 264,
    height: 244
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 44,
    y: 79,
    width: 112,
    height: 79
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 79,
    width: 112,
    height: 79,
    id: "mask-6_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5_2_",
    className: "st2",
    d: "M124,144.6V163h4l0,0c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4 c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0 c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    className: "st12",
    d: "M156,79v23c0,30.9-25.1,56-56,56s-56-25.1-56-56V79v15c0,30.9,25.1,56,56,56 s56-25.1,56-56V79z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clothes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166,29.3c37,3,66,34,66,71.8v8.9H32v-8.9C32,63,61.6,31.8,99,29.2c0,0.4,0,0.7,0,1.1 c0,11.9,15,21.5,33.5,21.5S166,42.2,166,30.3C166,30,166,29.6,166,29.3z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 110
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 110,
    id: "react-mask-952_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-951_1_",
    className: "st2",
    d: "M166,29.3c37,3,66,34,66,71.8v8.9H32v-8.9C32,63,61.6,31.8,99,29.2 c0,0.4,0,0.7,0,1.1c0,11.9,15,21.5,33.5,21.5S166,42.2,166,30.3C166,30,166,29.6,166,29.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 264,
    height: 110
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 92.9,
    y: 4.9,
    width: 79.3,
    height: 53.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 92.9,
    y: 4.9,
    width: 79.3,
    height: 53.8,
    id: "react-mask-952_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-951_2_",
    className: "st2",
    d: "M166,29.3c37,3,66,34,66,71.8v8.9H32v-8.9C32,63,61.6,31.8,99,29.2 c0,0.4,0,0.7,0,1.1c0,11.9,15,21.5,33.5,21.5S166,42.2,166,30.3C166,30,166,29.6,166,29.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadowy",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 40.5,
    cy: 27.8,
    rx: 39.6,
    ry: 26.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(76.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.1,15.1C36.2,24.6,44.2,32,54,32c9.8,0,17.9-7.4,18.9-17c0.1-0.8-0.8-2-1.8-2c-14.9,0-26.3,0-34,0 C36,13,35,14.2,35.1,15.1z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 39,
    y: 2,
    width: 31,
    height: 16
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 2,
    width: 31,
    height: 16,
    id: "react-mask-934_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-933_1_",
    className: "st2",
    d: "M35.1,15.1C36.2,24.6,44.2,32,54,32c9.8,0,17.9-7.4,18.9-17 c0.1-0.8-0.8-2-1.8-2c-14.9,0-26.3,0-34,0C36,13,35,14.2,35.1,15.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Teeth",
    className: "st20",
    d: "M44,2h21c2.8,0,5,2.2,5,5v6c0,2.8-2.2,5-5,5H44c-2.8,0-5-2.2-5-5V7C39,4.2,41.2,2,44,2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 38,
    y: 24,
    width: 32,
    height: 22
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 24,
    width: 32,
    height: 22,
    id: "react-mask-934_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-933_2_",
    className: "st2",
    d: "M35.1,15.1C36.2,24.6,44.2,32,54,32c9.8,0,17.9-7.4,18.9-17 c0.1-0.8-0.8-2-1.8-2c-14.9,0-26.3,0-34,0C36,13,35,14.2,35.1,15.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tongue",
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 21,
    cy: 11,
    r: 11
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    className: "st17",
    d: "M16,8c0,4.4,5.4,8,12,8l0,0c6.6,0,12-3.6,12-8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Squint",
    className: "st24",
    d: "M16.2,22.4C18,18.6,22.2,16,27,16c4.8,0,9,2.6,10.8,6.4c0.6,1.1-0.2,2-1,1.4 c-2.5-2.1-5.9-3.4-9.8-3.4c-3.7,0-7.1,1.2-9.6,3.2C16.5,24.3,15.6,23.6,16.2,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M74.2,22.4C76,18.6,80.2,16,85,16c4.8,0,9,2.6,10.8,6.4c0.6,1.1-0.2,2-1,1.4c-2.5-2.1-5.9-3.4-9.8-3.4 c-3.7,0-7.1,1.2-9.6,3.2C74.5,24.3,73.6,23.6,74.2,22.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    className: "st24",
    d: "M26.5,6.1c-5.8,0.3-15.2,4.5-15,10.3c0,0.2,0.3,0.3,0.4,0.1c2.8-3,22.3-5.9,29.2-4.4 c0.6,0.1,1.1-0.5,0.7-0.9C38.5,7.5,31.7,5.9,26.5,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M86.5,6.1c5.8,0.3,15.2,4.5,15,10.3c0,0.2-0.3,0.3-0.4,0.1c-2.8-3-22.3-5.9-29.2-4.4 c-0.6,0.1-1.1-0.5-0.7-0.9C74.5,7.5,81.3,5.9,86.5,6.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 264,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 264,
    height: 280,
    id: "react-mask-925_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "react-path-927_1_",
    className: "st2",
    width: 264,
    height: 280
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Short-Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M183.7,38.9c5.4-5,6.7-15,3.6-21.5c-3.8-8-11.4-9-18.7-5.5c-6.9,3.3-13.1,4.4-20.6,2.8 c-7.3-1.5-14.1-4.3-21.6-4.7C114,9.3,102,13.9,93.6,23.1c-1.6,1.8-2.9,3.8-4.1,5.8c-1,1.6-2.1,3.4-2.5,5.3 c-0.2,0.9,0.2,3.1-0.3,3.8c-0.5,0.8-2.3,1.5-3.1,2.1c-1.6,1.2-2.9,2.5-4.2,4c-2.7,3.2-4.1,6.6-5.4,10.6 c-4.1,13.2-4.5,29,0.9,42c0.7,1.7,2.9,5.4,4.2,1.6c0.3-0.7-0.3-3.2-0.3-3.9c0-2.7,1.5-20.7,8-30.8c2.1-3.3,12-15.6,14-15.7 c1.1,1.7,11.9,12.5,39.9,11.2c12.7-0.6,22.4-6.3,24.7-8.7c1,5.5,13,13.8,14.8,17.2c5.3,9.8,6.4,30.3,8.4,30.3 s3.5-5.2,3.9-6.2c3.1-7.4,3.6-16.6,3.3-24.6C195.5,57,191.3,45.9,183.7,38.9z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_9_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280,
    id: "react-mask-924_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-926_1_",
    className: "st2",
    d: "M183.7,38.9c5.4-5,6.7-15,3.6-21.5c-3.8-8-11.4-9-18.7-5.5 c-6.9,3.3-13.1,4.4-20.6,2.8c-7.3-1.5-14.1-4.3-21.6-4.7C114,9.3,102,13.9,93.6,23.1c-1.6,1.8-2.9,3.8-4.1,5.8 c-1,1.6-2.1,3.4-2.5,5.3c-0.2,0.9,0.2,3.1-0.3,3.8c-0.5,0.8-2.3,1.5-3.1,2.1c-1.6,1.2-2.9,2.5-4.2,4 c-2.7,3.2-4.1,6.6-5.4,10.6c-4.1,13.2-4.5,29,0.9,42c0.7,1.7,2.9,5.4,4.2,1.6c0.3-0.7-0.3-3.2-0.3-3.9 c0-2.7,1.5-20.7,8-30.8c2.1-3.3,12-15.6,14-15.7c1.1,1.7,11.9,12.5,39.9,11.2c12.7-0.6,22.4-6.3,24.7-8.7 c1,5.5,13,13.8,14.8,17.2c5.3,9.8,6.4,30.3,8.4,30.3s3.5-5.2,3.9-6.2c3.1-7.4,3.6-16.6,3.3-24.6 C195.5,57,191.3,45.9,183.7,38.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    width: 264,
    height: 280
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome);
export default __webpack_public_path__ + "static/media/img-home.0f323cfd395f03a2790f6c0b929ea787.svg";
export { ForwardRef as ReactComponent };